fx.ns("shared.popups", class SliceEditorPopup extends fx.components.Popup{

    constructor(component, model)
    {
        super(component.data);

        this.sliceComponent = component;
        this.model = model;

        this.contentWidth = 380;
        this.contentHeight = 120;
    }


    get font()
    {
        return this.model.fonts.find({id : this.data.font_family});
    }

    create()
    {
        super.create();

        this._container = new fx.components.VBox("container");
        
        //this.title = new fx.components.Text({text:fx.text("Texte de la tranche de l'album"), className : "title"});
        this.text = new fx.components.Input({placeHolder:fx.text("Entrez le texte de la tranche de l'album"), name:"text", value : /^\s+$/.test(Utils.stripHtml(this.data.content))?"":Utils.stripHtml(this.data.content)});
      
        
        this.fontList = new fx.components.VerticalSelect({items : this.model.fonts, selectedItem : this.font, notifyFirstSelect : false, labelRenderer : this._renderFont, hideIcon: true });

        // ---- text color
        let boxTextColor = new fx.components.Box("textColorContainer");

        this.textColor = new fx.components.IconButton({icon : fx.assets.textColorBtn, label : fx.text("Texte"), className : "textColor", iconRatio : 0.7});
        this.textColorPicker = new fx.components.ColorPicker({lastColors:this.model.customcolors, currentColor : "#000", showOpacity : false});
        this.textColorPicker.visibleAtStart = false;
        this.textColorPicker.currentColor = this.data.text_color;
        this.textColorPicker.effect = "vslide";
        
        boxTextColor.addChild(this.textColor, {width : 50});
        boxTextColor.addChild(this.textColorPicker, {top : 48, left : -116/*, width : 315, height:200*/});
        
        // ---- background color
        let boxBackgroundColor = new fx.components.Box("backgroundColorContainer");

        this.backgroundColor = new fx.components.IconButton({icon : fx.assets.textBgColorBtn, label : fx.text("Fond"), className : "backgroundColor", iconRatio : 0.7});
        this.backgroundColorPicker = new fx.components.ColorPicker({lastColors:this.model.customcolors, currentColor : "#000", showOpacity : false});
        this.backgroundColorPicker.visibleAtStart = false;
        this.backgroundColorPicker.effect = "vslide";

        boxBackgroundColor.addChild(this.backgroundColor, {width : 50});
        boxBackgroundColor.addChild(this.backgroundColorPicker, {top : 48, left : -116/*, width : 315, height:200*/});


        let rotateContainer = new fx.components.Box("rotateContainer");

        this.rotateButton = new fx.components.IconButton({icon : fx.assets.rotateBtn, label : fx.text("Tourner"), className : "rotateButton", iconRatio : 0.7});
        
        rotateContainer.addChild(this.rotateButton, {width : 50});
        
        
        this._containerH = new fx.components.HBox();

        //this._container.addChild(this.title, {width:"100%", height:50});
        this._container.addChild(this.text, {width:"100%", height:50});
        
        this._containerH.addChild(this.fontList, {width:180, height:30});
        
        this._containerH.addChild(boxTextColor, {width : 50, height : 50});
        this._containerH.addChild(boxBackgroundColor, {width : 50, height : 50});
        this._containerH.addChild(rotateContainer, {width : 50, height : 50});

        if (fx.get("app") == "config")
        {
            this.removeButton = new fx.components.LinkButton({label:fx.text("Supprimer"), className:"remove"});
            this._containerH.addChild(this.removeButton, {height : 50});
        }

        this._container.addChild(this._containerH, {width:"100%", height:50});

        this.addChild(this._container, {width : "360", top:"center", left : "center"});
    }
    

    onReady()
    {
        super.onReady();

        this.sliceComponent.selectAll()
        this.text.focus(true);

        this.text.css("font-family", this.font.name);
        //this.text.css("color", this.data.text_color);
        //this.text.css("color", "#000000");

        this.on("updated", this._textUpdated, this.text);
        this.on("selected", this._onFontSelected, this.fontList);

        this.on("click", this._toggleTextColor, this.textColor);
        this.on("click", this._toggleBackgroundColor, this.backgroundColor);
        this.on("selected" , this._onColorUpdated, this.textColorPicker);
        this.on("selected" , this._onBackgroundColorUpdated, this.backgroundColorPicker);
        this.on("click", this.rotateText, this.rotateButton);


        this.on("click", this._onClick);
        
        if (this.removeButton)
            this.on("click", this._onRemove, this.removeButton);

        
        this._defaultHeight = this.sliceComponent.acceptedSize.height;

        this._previousContent = this.data.content;
        this._previousValue = this.text.value;
    }

    onClose()
    {
        super.onClose();

        if (this.text.value && (this.text.value instanceof String) && (this.text.value.trim() == ""))
            this.data.delete();
    }

    _renderFont(font)
    {
        // The catalogue holds UI fonts with no thumb : rendering one would request /app/.../undefined.
        return (font && font.thumb) ? "<img class='image' src='" + font.thumb + "'>" : "";
    }

    _toggleTextColor(e)
    {
        this.textColorPicker.toggle();
        this.backgroundColorPicker.hide();
        e.stopPropagation();
        e.preventDefault();
    }

    _toggleBackgroundColor(e)
    {
        this.backgroundColorPicker.toggle();
        this.textColorPicker.hide();
        e.stopPropagation();
        e.preventDefault();
    }

    _onClick(e)
    {
        if (!fx.dom.parent(e.target,".ColorPicker"))
        {
            this.textColorPicker.hide();
            this.backgroundColorPicker.hide();
        }

    }

    _onRemove()
    {
        this.data.delete();
    }

    _onFontSelected()
    {
        //this.sliceComponent.selectAll();
        this.sliceComponent.onFontFamily(this.fontList.selectedItem);

        this.text.css("font-family", this.fontList.selectedItem.name);
    }

    _onColorUpdated()
    {
        this.sliceComponent.onTextColor(this.textColorPicker.currentColor);

        this.data.text_color = this.textColorPicker.currentColor;
        
        this.text.focus();
    }

    _onBackgroundColorUpdated()
    {
        this.model.book.cover.updateBackgroundColor(this.backgroundColorPicker.currentColor, "center", true);


        this.text.focus();
    }

    _textUpdated(e)
    {
        this._updateContent();

        this._onTextSizeUpdated(e);

        //this.text.focus();
    }

    rotateText()
    {
        if (this.data.rotation == 270)
            this.data.update("move", {  rotation : 90, 
                                x : (this.model.book.coverWidth - this.data.height) / 2 + this.data.height, 
                                y : (models.ProductBookPage.defaultSliceTextHeight()/2)
            });
        else
            this.data.update("move", {  rotation : 270, 
                                x : (this.model.book.coverWidth - this.data.height) / 2, 
                                y : this.model.book.coverHeight - (models.ProductBookPage.defaultSliceTextHeight()/2)
                            });
    }

    onDataEvent(e)
    {
        super.onDataEvent(e);

        if (e.type == "font-family-updated")
        {
            this.data.font_family = this.fontList.selectedItem.id;

            this._updateContent();
            this._onTextSizeUpdated();
        }
            
    }

    _updateContent(font_size)
    {
        if (!font_size)
            font_size = this.data.font_size;

        let color = this.textColorPicker.currentColor;
        let font = this.fontList.selectedItem;
        let text = String(this.text.value);
        
        if (text == "")
            text = " "; // trick in order to avoid loosing focus on text input (because of applying default settings on)
            
        let str = '<p style="text-align: center; font-size: ' + font_size + 'px;"><span style="color: ' + color + '; font-size: ' + font_size + 'px;font-family: ' + font.name + ';">' + text.replace(/ /g, '&nbsp;') + '</span></p>';
        this.data.update("update-content", {content : str, font_family : font.id, text_color : color} );
        this.text.focus();
    }


    _onTextSizeUpdated(e)
    {
        let area = this.sliceComponent._textEditor._editor.root.cloneNode(true);

        let width = fx.graphics.getTextWidthDOM(area, this.sliceComponent._textEditor._editor.root.parentNode);


        let fontSize = this.data.font_size;
        let minFontFize = (this.model.book.isSoft && this.model.book.numberPages < 60) ? 2 : 4;
        let maxFontFize = (this.model.book.isSoft && this.model.book.numberPages < 60) ? 3 : 5;

        if (fontSize < minFontFize)
        {
            this.data.font_size = minFontFize;
            this._updateContent(minFontFize);
            return;
        }

        if (fontSize > maxFontFize)
        {
            this.data.font_size = maxFontFize;
            this._updateContent(maxFontFize);
            return;
        }

        if (width >= this.sliceComponent.width - this.sliceComponent.MARGINS)
        {
            while (width >= this.sliceComponent.width - this.sliceComponent.MARGINS && fontSize > minFontFize)
            {
                fontSize--;
                area.innerHTML = area.innerHTML.replace(/font\-size\:\s?(\d+)px/g, "font-size:" + fontSize + "px");
                width = fx.graphics.getTextWidthDOM(area, this.sliceComponent._textEditor._editor.root.parentNode);
                
            }

            if (width < this.sliceComponent.width - this.sliceComponent.MARGINS && fontSize >= minFontFize)
            {
                this.data.font_size = fontSize;
                this._updateContent(fontSize);
                
            }
            else
            {
                this.data.update("update-content", {content : this._previousContent} );
                this.text.value = this._previousValue;
                return;
            }
        }
        else
        if (width < this.sliceComponent.width - this.sliceComponent.MARGINS)
        {
            while (width <= (this.sliceComponent.width - this.sliceComponent.MARGINS) && fontSize < maxFontFize)
            {
                fontSize++;
                area.innerHTML = area.innerHTML.replace(/font\-size\:\s?(\d+)px/g, "font-size:" + fontSize + "px");
                width = fx.graphics.getTextWidthDOM(area, this.sliceComponent._textEditor._editor.root.parentNode);
            }

            if ( fontSize != this.data.font_size)
            {
                if (width > (this.sliceComponent.width - this.sliceComponent.MARGINS))
                {
                    fontSize--;
                    area.innerHTML = area.innerHTML.replace(/font\-size\:\s?(\d+)px/g, "font-size:" + fontSize + "px");
                    width = fx.graphics.getTextWidthDOM(area, this.sliceComponent._textEditor._editor.root.parentNode);
                }

                if (width < this.sliceComponent.width - this.sliceComponent.MARGINS && fontSize <= maxFontFize)
                {
                    this.data.font_size = fontSize;
                    this._updateContent(fontSize);
                    
                }
            }
        }
        
        this._previousValue = this.text.value;
        this._previousContent = this.data.content;
    }

    
});